'use strict';

exports.__esModule = true;
exports['default'] = parseToRgb;

var _hslToRgb = /*#__PURE__*/ _interopRequireDefault(
    /*#__PURE__*/ require('../internalHelpers/_hslToRgb')
);

var _nameToHex = /*#__PURE__*/ _interopRequireDefault(
    /*#__PURE__*/ require('../internalHelpers/_nameToHex')
);

var _errors = /*#__PURE__*/ _interopRequireDefault(
    /*#__PURE__*/ require('../internalHelpers/_errors')
);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
var rgbaRegex =
    /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
var hslRegex =
    /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex =
    /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
    if (typeof color !== 'string') {
        throw new _errors['default'](3);
    }

    var normalizedColor = (0, _nameToHex['default'])(color);

    if (normalizedColor.match(hexRegex)) {
        return {
            red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16),
        };
    }

    if (normalizedColor.match(hexRgbaRegex)) {
        var alpha = parseFloat(
            (parseInt('' + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2)
        );
        return {
            red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha,
        };
    }

    if (normalizedColor.match(reducedHexRegex)) {
        return {
            red: parseInt('' + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt('' + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt('' + normalizedColor[3] + normalizedColor[3], 16),
        };
    }

    if (normalizedColor.match(reducedRgbaHexRegex)) {
        var _alpha = parseFloat(
            (parseInt('' + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2)
        );

        return {
            red: parseInt('' + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt('' + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt('' + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha,
        };
    }

    var rgbMatched = rgbRegex.exec(normalizedColor);

    if (rgbMatched) {
        return {
            red: parseInt('' + rgbMatched[1], 10),
            green: parseInt('' + rgbMatched[2], 10),
            blue: parseInt('' + rgbMatched[3], 10),
        };
    }

    var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));

    if (rgbaMatched) {
        return {
            red: parseInt('' + rgbaMatched[1], 10),
            green: parseInt('' + rgbaMatched[2], 10),
            blue: parseInt('' + rgbaMatched[3], 10),
            alpha: parseFloat('' + rgbaMatched[4]),
        };
    }

    var hslMatched = hslRegex.exec(normalizedColor);

    if (hslMatched) {
        var hue = parseInt('' + hslMatched[1], 10);
        var saturation = parseInt('' + hslMatched[2], 10) / 100;
        var lightness = parseInt('' + hslMatched[3], 10) / 100;
        var rgbColorString = 'rgb(' + (0, _hslToRgb['default'])(hue, saturation, lightness) + ')';
        var hslRgbMatched = rgbRegex.exec(rgbColorString);

        if (!hslRgbMatched) {
            throw new _errors['default'](4, normalizedColor, rgbColorString);
        }

        return {
            red: parseInt('' + hslRgbMatched[1], 10),
            green: parseInt('' + hslRgbMatched[2], 10),
            blue: parseInt('' + hslRgbMatched[3], 10),
        };
    }

    var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));

    if (hslaMatched) {
        var _hue = parseInt('' + hslaMatched[1], 10);

        var _saturation = parseInt('' + hslaMatched[2], 10) / 100;

        var _lightness = parseInt('' + hslaMatched[3], 10) / 100;

        var _rgbColorString =
            'rgb(' + (0, _hslToRgb['default'])(_hue, _saturation, _lightness) + ')';

        var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

        if (!_hslRgbMatched) {
            throw new _errors['default'](4, normalizedColor, _rgbColorString);
        }

        return {
            red: parseInt('' + _hslRgbMatched[1], 10),
            green: parseInt('' + _hslRgbMatched[2], 10),
            blue: parseInt('' + _hslRgbMatched[3], 10),
            alpha: parseFloat('' + hslaMatched[4]),
        };
    }

    throw new _errors['default'](5);
}

module.exports = exports.default;
